import React from 'react';

import LOGO_EASYTIP from 'assets/slickpay-splash/tip/easytip.png';
import ICO_GREEN from 'assets/slickpay-splash/tip/green-check.png';
import LOGO_PHOREST from 'assets/slickpay-splash/tip/phorest.png';
import ICO_RED from 'assets/slickpay-splash/tip/red-check.png';
import LOGO_SLICK from 'assets/slickpay-splash/tip/slick.png';
import LOGO_THANKYOU from 'assets/slickpay-splash/tip/thankyou.png';
import LOGO_TIPJAR from 'assets/slickpay-splash/tip/tipjar.png';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import createNodeKey from 'utils/react/createNodeKey.util';
import C from 'utils/values/constant.util';

import CN from './TableTippingRates.module.scss';

const columns = (t) =>
  C([
    t('staffKpisReports.staffTipping.tippingRates.benefits.monthly'),
    t('staffKpisReports.staffTipping.tippingRates.benefits.transaction'),
    t('staffKpisReports.staffTipping.tippingRates.benefits.qr'),
    t('staffKpisReports.staffTipping.tippingRates.benefits.tap'),
    t('staffKpisReports.staffTipping.tippingRates.benefits.payout'),
  ]);

const TableTippingRates = () => {
  const { t } = useTranslation();

  const benefits = columns(t);

  return (
    <div data-bem="TableTippingRates" className={CN.component}>
      <div className={CN.title} data-bem="TableTippingRates__title">
        {t('staffKpisReports.staffTipping.tippingRates.title')}
      </div>
      <div className={CN.outer}>
        <div className={CN.tableContainer}>
          <div className={CN.tableHeader} data-bem="TableTippingRates__header">
            <div className={CN.headerFixedCell}>{t('staffKpisReports.staffTipping.tippingRates.provider')}</div>
            {asArray(benefits).map((column, columnIndex) => (
              <div key={createNodeKey({ columnIndex })} className={CN.cellHeader}>
                {column}
              </div>
            ))}
          </div>
          {/* row SLICK */}
          <div className={CN.scrollBody} data-bem="TableTippingRates__body">
            <div className={CN.tableRow} data-bem="TableTippingRates__row--slick">
              <div className={CN.fixedColumnCell} data-bem="TableTippingRates__fixed-first-cell">
                <img src={LOGO_SLICK} alt="Slick logo" className={CN.logo} />
              </div>
              <div className={CN.highlightCell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.slick.monthlyFee')}
              </div>
              <div className={CN.highlightCell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.slick.transactionFee')}
              </div>
              <div className={CN.cell}>
                <img src={ICO_GREEN} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>
                <img src={ICO_GREEN} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.highlightCell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.slick.payout')}
              </div>
            </div>

            {/* row EASYTIP */}
            <div className={CN.tableRow} data-bem="TableTippingRates__row--easytip">
              <div className={CN.fixedColumnCell} data-bem="TableTippingRates__fixed-first-cell">
                <img src={LOGO_EASYTIP} alt="Easy Tip logo" className={CN.logo} />
              </div>
              <div className={CN.cell}>
                <CurrencySign value={t('staffKpisReports.staffTipping.tippingRates.providers.easyTip.monthlyFee')} />
              </div>
              <div className={CN.cell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.easyTip.transactionFeePart1')}
                <span className={CN.cellInfo}>
                  {t('staffKpisReports.staffTipping.tippingRates.providers.easyTip.transactionFeePart2')}
                </span>
              </div>
              <div className={CN.cell}>
                <img src={ICO_RED} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>
                <img src={ICO_RED} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>{t('staffKpisReports.staffTipping.tippingRates.providers.easyTip.payout')}</div>
            </div>

            {/* row TIPJAR */}
            <div className={CN.tableRow} data-bem="TableTippingRates__row-tipjar">
              <div className={CN.fixedColumnCell} data-bem="TableTippingRates__fixed-first-cell">
                <img src={LOGO_TIPJAR} alt="TipJar logo" className={CN.logo} />
              </div>
              <div className={CN.cell}>
                <CurrencySign value={t('staffKpisReports.staffTipping.tippingRates.providers.tipJar.monthlyFee')} />
              </div>
              <div className={CN.cell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.tipJar.transactionFeePart1')}
                <span className={CN.cellInfo}>
                  {t('staffKpisReports.staffTipping.tippingRates.providers.tipJar.transactionFeePart2')}
                </span>
              </div>
              <div className={CN.cell}>
                <img src={ICO_RED} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>
                <img src={ICO_RED} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>{t('staffKpisReports.staffTipping.tippingRates.providers.tipJar.payout')}</div>
            </div>

            {/* row THANKYOU */}
            <div className={CN.tableRow} data-bem="TableTippingRates__row--thankyou">
              <div className={CN.fixedColumnCell} data-bem="TableTippingRates__fixed-first-cell">
                <img src={LOGO_THANKYOU} alt="Thank you logo" className={CN.logo} />
              </div>
              <div className={CN.cell}>
                <CurrencySign
                  value={t('staffKpisReports.staffTipping.tippingRates.providers.thankU.monthlyFeePart1')}
                />
                <span className={CN.cellInfo}>
                  {t('staffKpisReports.staffTipping.tippingRates.providers.thankU.transactionFeePart2')}
                </span>
              </div>
              <div className={CN.cell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.thankU.transactionFeePart1')}
                <span className={CN.cellInfo}>
                  {t('staffKpisReports.staffTipping.tippingRates.providers.thankU.transactionFeePart2')}
                </span>
              </div>
              <div className={CN.cell}>
                <img src={ICO_RED} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>
                <img src={ICO_RED} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>{t('staffKpisReports.staffTipping.tippingRates.providers.thankU.payout')}</div>
            </div>
            {/* row PHOREST */}
            <div className={CN.tableRow} data-bem="TableTippingRates__row--phorest">
              <div className={CN.fixedColumnCell} data-bem="TableTippingRates__fixed-first-cell">
                <img src={LOGO_PHOREST} alt="Phorest logo" className={CN.logo} />
              </div>
              <div className={CN.cell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.phorest.monthlyFee')}
              </div>
              <div className={CN.cell}>
                {t('staffKpisReports.staffTipping.tippingRates.providers.phorest.transactionFee')}
              </div>
              <div className={CN.cell}>
                <img src={ICO_GREEN} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>
                <img src={ICO_GREEN} alt="Check" className={CN.icoCheck} />
              </div>
              <div className={CN.cell}>{t('staffKpisReports.staffTipping.tippingRates.providers.phorest.payout')}</div>
            </div>
          </div>
        </div>
      </div>
      <div data-bem="TableTippingRates__notes" className={CN.tableNotes}>
        {t('staffKpisReports.staffTipping.tippingRates.providerNote')}
      </div>
    </div>
  );
};

export default TableTippingRates;
